import { render, staticRenderFns } from "./manageGoods1.vue?vue&type=template&id=10f2ac54&scoped=true&"
import script from "./manageGoods1.vue?vue&type=script&lang=js&"
export * from "./manageGoods1.vue?vue&type=script&lang=js&"
import style0 from "./manageGoods1.vue?vue&type=style&index=0&id=10f2ac54&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f2ac54",
  null
  
)

export default component.exports